import { Col } from "react-bootstrap";

import { DEFAULT_VALUE } from "../../../constants";
import { buildTestId, compactNumberFormat } from "../../../../../shared";

const BreakdownItem = ({ label, data, borderClass }) => {
  if (!data) return null;

  const itemTestId = buildTestId("breakdown-item", label);
  const valueTestId = buildTestId("breakdown-item", label, "value");
  const percentageTestId = buildTestId("breakdown-item", label, "percentage");

  return (
    <Col xs={6}>
      <div
        className={`d-flex flex-column gap-2 p-2 rounded-2 custom-breakdown-item h-100 insights-card ${borderClass}`}
        data-testid={itemTestId}
      >
        <span className="text-secondary text-uppercase small">{label}</span>
        <div className="d-flex gap-2 align-items-baseline">
          <span
            className="fw-bolder insight-value"
            data-testid={valueTestId}
          >
            {compactNumberFormat(data.value ?? DEFAULT_VALUE)}
          </span>
          <span
            className="text-secondary"
            data-testid={percentageTestId}
          >
            {data.percentage ?? DEFAULT_VALUE}%
          </span>
        </div>
      </div>
    </Col>
  );
};

export default BreakdownItem;
